import { BrowserDetails } from "../../utility/browserDetails"

const setHubspotutkCookie = value => {
  var match = document.cookie.match(new RegExp("(^| )" + value + "=([^;]+)"))
  if (match) return match[2]
}

const getAdditionalInfo = (captchaStatus, requiredParams) => {
  return [
    {
      name: "sopsreferral",
      value: sessionStorage.getItem("sopsreff") ?? "No Referral",
    },
    {
      name: "sops_first_page_seen",
      value: sessionStorage.getItem("landing") ?? "No First page seen",
    },
    {
      name: "sops_last_page_seen",
      value: document.location.href,
    },
    {
      name: "utm_campaign",
      value: requiredParams?.utm_campaign ?? "No value",
    },
    {
      name: "utm_medium",
      value: requiredParams?.utm_medium ?? "No value",
    },
    {
      name: "utm_source",
      value: requiredParams?.utm_source ?? "No value",
    },
    {
      name: "utm_term",
      value: requiredParams?.utm_term ?? "No value",
    },
    {
      name: "signup_info",
      value: `hubspot-cookie : ${
        setHubspotutkCookie("hubspotutk") ? "available" : "not available"
      }, Browser: ${BrowserDetails.browserName}, Browser version: ${
        BrowserDetails.fullVersion
      }, OS : ${BrowserDetails.OSName}, Device type: ${
        BrowserDetails.deviceType
      }, Device resolution: ${
        BrowserDetails.resolution
      }, Captcha status: ${captchaStatus}`,
    },
  ]
}

const sendEventHumioLog = (data, responseText, message) => {
  let log_data = {
    finalData: data,
    response: responseText,
  }

  window.logger && window.logger.info(message, log_data)
  window.logger && window.logger.flush()
}

export default function handleFormSubmit(
  items,
  endpoint,
  pageUri,
  pageName,
  pathName,
  errorHandler,
  callback
) {
  var xhr = new XMLHttpRequest()
  var url = endpoint
  var additionalInfo = getAdditionalInfo()
  var data = {
    submittedAt: Date.now(),
    fields: [...items, ...additionalInfo],
    context: {
      hutk: setHubspotutkCookie("hubspotutk"),
      pageUri: pageUri,
      pageName: `${pageName}`,
    },
  }

  var final_data = JSON.stringify(data)

  sendEventHumioLog(
    final_data,
    {},
    `Before hitting submit from ${document.URL}`
  )

  xhr.open("POST", url)

  xhr.setRequestHeader("Content-Type", "application/json")

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      callback && callback()
      sendEventHumioLog(
        final_data,
        xhr.responseText,
        `After hitting submit & got success from ${document.URL}`
      )
      if (pathName) {
        let path = pathName.split("/")[1]
        window.location.href = `/thank-you?src=${path}`
      } else {
        // console.log("inside else")
      }
    } else if (
      xhr.readyState === 4 &&
      (xhr.status === 400 || xhr.status === 403 || xhr.status === 404)
    ) {
      sendEventHumioLog(
        final_data,
        xhr.responseText,
        `After hitting submit & got failed from ${document.URL}`
      )
      const response = JSON.parse(xhr.responseText)
      errorHandler(data, response)
    }
  }
  xhr.send(final_data)
  // process.env.ENV_NAME === "production" && xhr.send(final_data)
  if (final_data) {
    return true
  } else {
    return false
  }
}

export { getAdditionalInfo, sendEventHumioLog, setHubspotutkCookie }
